module.exports = __webpack_public_path__ + "static/media/edge.beca4845.png";